<template>
<el-radio-group v-model="unitProp" :size="size" @change="onSelectChanged">
  <el-radio-button label="stdUnit">原始单位</el-radio-button>
  <el-radio-button label="displayUnit">常用单位</el-radio-button>
</el-radio-group>
</template>

<script>
export default {
  name: 'UnitSwitch',
  props: {
    defaultUnitProp: {
      required: true,
      type: String
    },
    size: {
      type: String,
      default: 'small'
    }
  },
  data () {
    return {
      unitProp: this.defaultUnitProp
    }
  },
  methods: {
    onSelectChanged (unitProp) {
      this.$emit('update:defaultUnitProp', unitProp)
      this.$emit('change', unitProp)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Data/UnitSwitch.vue